import { faTrashCan } from "@fortawesome/pro-solid-svg-icons";
import type { BatchAction } from "@components/CatalogIndex";

export const buildWebhookBatchActions = (
  onDelete: () => void
): BatchAction[] => [
  {
    icon: faTrashCan,
    label: "Delete",
    onClick: onDelete,
    variant: "danger",
  },
];
